import { UPDATE_TOP_STORES_WIDGET } from "./actionTypes"

export const updateTopStoresWidget = data => {
  return {
    type: UPDATE_TOP_STORES_WIDGET,
    payload: data,
  }
}
